//
//
//
//

import CopyUrl from '@/components/ui/CopyUrl'

export default {
  name: 'CopyProfileUrl',
  components: {
    CopyUrl
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    fullUrl () {
      const lang = this.$store.getters['util/getCurrentLanguage']
      return process.client ? `${window.location.protocol}//${window.location.host}/${lang.code}/${this.url}` : ''
    }
  },
  methods: {
    async handleCopy () {
      await this.$store.dispatch('ui/showNotification', {
        type: 'success',
        text: this.$t('common.copy_success')
      })
    }
  }
}
